// extracted by mini-css-extract-plugin
export default {"Container":"Purchases_Container__1YqkH","Logo":"Purchases_Logo__DoHL4","Purchases":"Purchases_Purchases__9KIYy","Purchases__Message":"Purchases_Purchases__Message__wvpI-"};